<div
  class="bs-listbox rounded"
  [ngClass]="styleClass()"
  [ngStyle]="style()"
  [class.bs-listbox--virtual]="useVirtualScroll()"
  [class.is-disabled]="isDisabled()"
  [attr.aria-disabled]="isDisabled()"
>
  @if (headerTemplate()) {
    <div class="bs-listbox-header">
      <ng-container [ngTemplateOutlet]="headerTemplate()"></ng-container>
    </div>
  }
  @if (filter() || multiple()) {
    <div class="bs-listbox-filter d-flex flex-nowrap align-items-center input-group rounded-top ps-1 pe-3 py-3">
      @if (selectAllToggleState()) {
        <input
          class="form-check-input bs-listbox-checkbox me-3"
          type="checkbox"
          [checked]="selectAllState()"
          [disabled]="isDisabled() || readOnly()"
          (change)="onToggleAll($event)"
          (keydown)="onToggleAllCheckboxKeydown($event)"
          id="{{ idComputed() }}-toggle"
        />
      }
      @if (filter()) {
        @if (filterTemplate()) {
          <ng-container
            [ngTemplateOutlet]="filterTemplate()"
            [ngTemplateOutletContext]="{ options: filterOptions() }"
          ></ng-container>
        } @else {
          <div class="input-group rounded-start">
            <input
              class="form-control"
              type="text"
              [placeholder]="filterPlaceHolder()"
              [attr.aria-label]="ariaFilterLabel()"
              [value]="filterValue() ?? ''"
              (input)="onFilterInput($event)"
            />
            <span class="input-group-text">
          @if (filterIconTemplate()) {
            <ng-container [ngTemplateOutlet]="filterIconTemplate()"></ng-container>
          } @else {
            <i class="fa-solid fa-magnifying-glass"></i>
          }
        </span>
          </div>
        }
      }
    </div>
  }

  <div
    class="bs-listbox-list-container p-1 rounded-bottom overflow-scroll"
    [class.bs-listbox-list-container--virtual]="useVirtualScroll()"
    [style.max-height]="useVirtualScroll() ? null : scrollHeight()"
    [ngClass]="listStyleClass()"
    [ngStyle]="listStyle()"
  >
    @if (useVirtualScroll()) {
      <cdk-virtual-scroll-viewport
        #viewport
        class="bs-listbox-viewport"
        [itemSize]="virtualScrollItemSize()"
      >
        @if (showEmptyMessage()) {
          <div class="bs-listbox-empty list-group-item">
            @if (emptyTemplate()) {
              <ng-container [ngTemplateOutlet]="emptyTemplate()"></ng-container>
            } @else {
              {{ emptyMessageText() }}
            }
          </div>
        } @else {
          <ul
            class="bs-listbox-list list-group"
            role="listbox"
            [attr.id]="idComputed()"
            [attr.tabindex]="tabindex()"
            [attr.aria-label]="ariaLabel()"
            [attr.aria-labelledby]="ariaLabelledBy()"
            [attr.aria-multiselectable]="multiple()"
            [attr.aria-activedescendant]="activeDescendantId()"
            (focus)="focus($event)"
            (blur)="blur($event)"
            (keydown)="onKeydown($event)"
          >
            <li
              *cdkVirtualFor="let wrappedOption of wrappedFlatOptions(); let i = index; trackBy: trackByWrappedOption"
              bsListboxOption
              class="bs-listbox-option ps-2 list-group-item rounded my-1"
              [class.active]="highlightOnSelect() && selectedOptionIndex()[wrappedOption.key]"
              [class.bs-listbox-striped]="striped() && i % 2 === 1"
              [class.disabled]="isOptionDisabled(wrappedOption.option)"
              [attr.id]="optionId(i)"
              [attr.role]="'option'"
              [attr.aria-selected]="selectedOptionIndex()[wrappedOption.key]"
              [attr.aria-disabled]="isOptionDisabled(wrappedOption.option)"
              [label]="getOptionLabel(wrappedOption.option)"
              [disabledState]="isOptionDisabled(wrappedOption.option)"
              (click)="onOptionClick($event, wrappedOption.option)"
              (dblclick)="onOptionDblClick($event, wrappedOption.option)"
              (mouseenter)="onOptionHover(wrappedOption.option)"
            >
              <ng-container
                [ngTemplateOutlet]="optionContent"
                [ngTemplateOutletContext]="{
                      $implicit: wrappedOption.option,
                      index: i,
                      selected: selectedOptionIndex()[wrappedOption.key]
                    }"
              ></ng-container>
            </li>
          </ul>
        }
      </cdk-virtual-scroll-viewport>
    } @else {
      <ul
        class="bs-listbox-list list-group"
        role="listbox"
        [attr.id]="idComputed()"
        [attr.tabindex]="tabindex()"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-labelledby]="ariaLabelledBy()"
        [attr.aria-multiselectable]="multiple()"
        [attr.aria-activedescendant]="activeDescendantId()"
        (focus)="focus($event)"
        (blur)="blur($event)"
        (keydown)="onKeydown($event)"
      >
        @if (group()) {
          @for (groupOption of wrappedGroups(); track trackByGroup($index, groupOption); let groupIndex =
            $index) {
            <li class="bs-listbox-option-group ps-2 list-group-item">
              <ng-container
                [ngTemplateOutlet]="groupTemplate() ?? defaultGroup"
                [ngTemplateOutletContext]="{ $implicit: groupOption.raw }"
              ></ng-container>
            </li>
            @for (wrappedOption of groupOption.items; track wrappedOption.key; let optionIndex = $index) {
              <li
                bsListboxOption
                class="bs-listbox-option ps-2 list-group-item rounded my-1"
                [class.active]="highlightOnSelect() && selectedOptionIndex()[wrappedOption.key]"
                [class.bs-listbox-striped]="striped() && optionIndex % 2 === 1"
                [class.disabled]="isOptionDisabled(wrappedOption.option)"
                [attr.id]="optionIdFromGroup(groupIndex, optionIndex)"
                [attr.role]="'option'"
                [attr.aria-selected]="selectedOptionIndex()[wrappedOption.key]"
                [attr.aria-disabled]="isOptionDisabled(wrappedOption.option)"
                [label]="getOptionLabel(wrappedOption.option)"
                [disabledState]="isOptionDisabled(wrappedOption.option)"
                (click)="onOptionClick($event, wrappedOption.option)"
                (dblclick)="onOptionDblClick($event, wrappedOption.option)"
                (mouseenter)="onOptionHover(wrappedOption.option)"
              >
                <ng-container
                  [ngTemplateOutlet]="optionContent"
                  [ngTemplateOutletContext]="{
                        $implicit: wrappedOption.option,
                        index: optionIndex,
                        selected: selectedOptionIndex()[wrappedOption.key]
                      }"
                ></ng-container>
              </li>
            }
          }
        } @else {
          @for (wrappedOption of wrappedFlatOptions(); track wrappedOption.key; let optionIndex =
            $index) {
            <li
              bsListboxOption
              class="bs-listbox-option list-group-item rounded my-1 py-1 ps-2"
              [class.active]="highlightOnSelect() && selectedOptionIndex()[wrappedOption.key]"
              [class.bs-listbox-striped]="striped() && optionIndex % 2 === 1"
              [class.disabled]="isOptionDisabled(wrappedOption.option)"
              [attr.id]="optionId(optionIndex)"
              [attr.role]="'option'"
              [attr.aria-selected]="selectedOptionIndex()[wrappedOption.key]"
              [attr.aria-disabled]="isOptionDisabled(wrappedOption.option)"
              [label]="getOptionLabel(wrappedOption.option)"
              [disabledState]="isOptionDisabled(wrappedOption.option)"
              (click)="onOptionClick($event, wrappedOption.option)"
              (dblclick)="onOptionDblClick($event, wrappedOption.option)"
              (mouseenter)="onOptionHover(wrappedOption.option)"
            >
              <ng-container
                [ngTemplateOutlet]="optionContent"
                [ngTemplateOutletContext]="{
                      $implicit: wrappedOption.option,
                      index: optionIndex,
                      selected: selectedOptionIndex()[wrappedOption.key]
                    }"
              ></ng-container>
            </li>
          }
        }
        @if (showEmptyMessage()) {
          <li class="bs-listbox-empty list-group-item">
            @if (emptyTemplate()) {
              <ng-container [ngTemplateOutlet]="emptyTemplate()"></ng-container>
            } @else {
              {{ emptyMessageText() }}
            }
          </li>
        }
      </ul>
    }
  </div>

  @if (footerTemplate()) {
    <div class="bs-listbox-footer">
      <ng-container [ngTemplateOutlet]="footerTemplate()"></ng-container>
    </div>
  }

  <span class="visually-hidden" aria-live="polite">{{ selectionAriaMessage() }}</span>

  <ng-template #optionContent let-option let-index="index" let-selected="selected">
    @if (checkbox()) {
      <input
        class="form-check-input bs-listbox-checkbox me-0"
        type="checkbox"
        [checked]="selected"
        [disabled]="isOptionDisabled(option) || readOnly() || isDisabled()"
        (click)="$event.stopPropagation()"
        (change)="onOptionCheckboxChange($event, option)"
        (keydown)="onOptionCheckboxKeydown($event, option)"
      />
    }

    <ng-container
      [ngTemplateOutlet]="itemTemplate() ?? defaultItem"
      [ngTemplateOutletContext]="{ $implicit: option, index: index }"
    ></ng-container>

    @if (checkmark()) {
      <span class="bs-listbox-checkmark ms-auto">
        @if (checkmarkTemplate()) {
          <ng-container
            [ngTemplateOutlet]="checkmarkTemplate()"
            [ngTemplateOutletContext]="{ $implicit: selected }"
          ></ng-container>
        } @else {
          @if (selected) {
            @if (checkIconTemplate()) {
              <ng-container [ngTemplateOutlet]="checkIconTemplate()"></ng-container>
            } @else {
              <span aria-hidden="true">&#10003;</span>
            }
          }
        }
      </span>
    }
  </ng-template>

  <ng-template #defaultItem let-option>
    <span class="bs-listbox-label">{{ getOptionLabel(option) }}</span>
  </ng-template>

  <ng-template #defaultGroup let-group>
    <span class="bs-listbox-group-label">{{ getGroupLabel(group) }}</span>
  </ng-template>
</div>
